<template>
  <div class="Componycontainer">
    <my-header></my-header>
    <!-- 返回顶部 -->
    <div class="backTop hide">
      <img @click="backTop" src="../assets/img/fanhuidingbu.png">
    </div>
    <!-- 新闻动态 顶部 -->
    <div class="content">
      <div class="banner">
        <img src="@/assets/img/dabeijing.png" alt="">
        <div>
          <p class="p1">新闻动态</p>
          <p class="p2">NEWS INFORMATION</p>
        </div>
      </div>
      <div class="title">
        <div class="p1"><span class="bfTitle">您的位置：</span><router-link :to="{ path: 'news',query:{id:8,page:1,queryTime:4} }" tag ="span"><span class="oneText"> 新闻动态 </span></router-link> <span style="margin:0 1%">＞</span> <p class="TitleSpan"> {{newDetail.title }}</p></div>
      </div>
      <!-- 新闻内容 -->
      <div class="main">
        <div class="main-right">
          <div class="newsContent">
            <div class="newsTitle">
              <p class="ntitle">{{ newDetail.title }}</p>
            </div>
            <div class="minTitle">
              <div>
                <span>新闻来源：</span><span> {{newDetail.source}}</span>
              </div>
              <div>
                <span>发布时间：</span> <span>{{newDetail.addTime}}</span>
              </div>
            </div>
            <div class="ncontent"  v-html="newDetail.content"></div>
          </div>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>
<script>
  import Vue from 'vue';
  import axios from 'axios';
  import myHeader from "@/components/Headers.vue";
  import myFooter from "@/components/Footers.vue";
  export default {
    data() {
      return {
        newDetail:{},
        current:'',
        i:0,
      }
    },
    components:{
      myHeader,
      myFooter,
    },
    methods: {
      //监听鼠标滚动的长度
      scrollToTop(){
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // 滚动的长度大于300时，顶部导航加背景，白色logo换成蓝色logo
        if(scrollTop>$('.banner').height()-50){
          $('ul :nth-child(2)').removeClass('bannerOne')
          $('ul :nth-child(2)').addClass('bannerTwo')
          $('header').removeClass('goheader')
          $('header').addClass('headerbg')
          $('.img1').addClass('hide')
          $('.img2.hide').removeClass('hide')
          $('.backTop').removeClass('hide')
        }else{
          $('ul :nth-child(2)').removeClass('bannerTwo')
          $('ul :nth-child(2)').addClass('bannerOne')
          $('header').removeClass('headerbg')
          $('.img1').removeClass('hide')
          $('.img2').addClass('hide')
          $('.backTop').addClass('hide')
        }
      },
      // 点击以300ms的速度返回顶部
      backTop(){
        $('body,html').animate({scrollTop:0},300)
      },
      addClass:function(item){
        this.current=item.id
        this.customerNum=item.id
        this.$router.push(`./news?id=${item.id}&page=1`)
      },
      getStatus (urlStr) {
        this.customerNum = urlStr || 8
        this.current = urlStr || 8
      },
      //修改——转换日期格式(时间戳转换为datetime格式)
      timestampToTime(timestamp) {
        var date = new Date(parseInt(timestamp, 10));
        var Y = date.getFullYear() ;
        var M = date.getMonth() + 1;
        var D = date.getDate() ;
        var h = date.getHours();
        var m = date.getMinutes();
        var s = date.getSeconds()

        return Y + '.' + M + '.' + D ;
      }
    },
    mounted() {
      // 监听滚动条的滚动长度
      window.addEventListener('scroll', this.scrollToTop)
      this.customerNum = this.$route.query.cateId
      this.current = this.$route.query.cateId
      axios.get(`http://zzrunta.com/bxsite/api/newsInformation/detailsNewsInformation?id=${this.$route.query.id}`).then((res)=>{
        if(res.data.news.addTime!=null){
          res.data.news.addTime = this.timestampToTime(res.data.news.addTime)
        }else{
          res.data.news.addTime = null
        }
        this.newDetail = res.data.news
      })
    },
    watch: {
      '$route' (to, from) {
        this.getStatus(this.$route.query.cateId)
      }
    },
  }
</script>
<style scoped lang = "scss">
  @import '@/lib/reset.scss';
  .Componycontainer{
    /* 返回顶部 */
    .backTop{
      position: fixed;
      right: 2%;
      bottom:3%;
      z-index: 2;
    }
    .backTop img{
      width: 50px;
    }
    .backTop img:hover{

    }
    .hide{display: none}
    /* header 新闻动态详情顶部图片+文字 */
    .content .banner{
      position: relative;
      width: 100%;
      height: auto;
      overflow: hidden;
    }
    .content .banner div{
      position: absolute;
      top:35%;
      left:43%;
    }
    .content .banner img{
      position: relative;
      width:100%;
    }
    .content .banner div .p1{
      font-size: 65px;
      line-height: 65px;
      color: #fff;
    }
    .content .banner div .p2{
      font-size:27px;
      color: #fff;
    }
    /* title 位置 */
    .content .title{
      margin:1% 20% 1%;
      display: flex
    }
    .content .title .p1 .bfTitle,.content .title .p1 .oneText{
      white-space: nowrap;
    }
    .content .title .p1 .TitleSpan{
      width:570px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .content .title .p1 .TitleSpan:hover{
      cursor: pointer;
    }
    .content .title .p1{
      font-size: 20px;
      color: #888;
      line-height: 1.5;
      margin-bottom: 20px;
      display: flex
    }
    .content .title .p2{
      font-size: 35px;
      color: #333;
      line-height: 50px;
    }
    /* 内容 */
    .main{
      margin: 0% 20% 2%;
      line-height: 40px;
    }
    /* 内容标题 */
    .ntitle{
      font-size: 28px;
      color:#333;
      line-height: 50px;
      font-weight: bold;
    }
    .minTitle{
      text-align: center;
      margin: 2% 0;
    }
    .minTitle div{
      display: inline-block;
      font-size: 16px;
      color:#888;
    }
    .minTitle div:nth-child(1){
      margin-right: 3%
    }
    .minTitle div:nth-child(2){
      margin-left: 3%
    }
    /* 内容正文 */
    .ncontent{
      font-size: 20px;
      color:#666;
    }
    @media screen and (max-width:1440px) and (min-width:1366px){
      /* header 新闻动态详情顶部图标+文字 */
      .content .banner div{
        position: absolute;
        top:36%;
        left: 41%;
        text-align: left;
      }

      .content .title .p1{
        font-size: 20px;
      }
      .content .banner div .p1{
        font-size:55px;
        line-height: 60px;
      }
      .content .banner div .p2{
        font-size:23px;
      }
      .ntitle{
        font-size: 25px;
      }
      /* 返回顶部 */
      .backTop{
        position:fixed;
        top:93%;
        right: 2%;
        z-index:2;
      }
      .backTop img{
        width:45px;
      }
    }
    @media screen and (max-width:1366px) and (min-width:1280px){
      /* header 新闻动态详情顶部图片+文字 */
      .content .banner div{
        position:absolute;
        top:33%;
        left:41%;
        text-align: left;
      }
      .content .title .p1{
        font-size: 18px;
      }
      .content .banner div .p1{
        font-size: 53px;
        line-height: 57px;
      }
      .ntitle{
        font-size: 20px;
      }
      .content .banner div .p2{
        font-size: 22px;
      }
      /* 返回顶部 */
      .backTop{
        position:fixed;
        top:92%;
        right:2%;
        z-index:2;
      }
      .backTop img{
        width: 40px;
      }
    }
    @media screen and (max-width:1280px) and (min-width:1024px){
      /* header 新闻动态详情顶部图片+文字 */
      .content .banner div{
        position: absolute;
        top:37%;
        left:41%;
        text-align: left;
      }
      .ntitle{
        font-size: 18px;
      }
      .content .title .p1{
        font-size: 16px;
      }
      .content .banner div .p1{
        font-size: 46px;
        line-height: 50px;
      }
      .content .banner div .p2{
        font-size:20px;
      }
      /* 返回顶部 */
      .backTop{
        position:fixed;
        top:92%;
        right: 2%;
        z-index:2;
      }
      .backTop img{
        width:40px;
      }
    }
    @media screen and (max-width:1024px) and (min-width:650px){
      /*  */
      .content .banner div{
        position: absolute;
        top:34%;
        left:39%;
        text-align: left;
      }
      .ntitle{
        font-size: 18px;
      }
      .content .banner div .p1{
        font-size:42px;
        line-height: 40px;
      }
      .content .title .p1{
        font-size: 16px;
      }
      .content .banner div .p2{
        font-size:17px;
        line-height: 40px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NewsDetail.vue